type Props = {
  className?: string;
};

export function Preferences({ className }: Props): React.ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 115 115" className={className}>
      <title>Preferences</title>
      <path
        d="M70.7,89.16c-.46,1.86-.84,3.5-1.29,5.11a1.31,1.31,0,0,1-.73.73c-4.63,1.56-9.19,3.46-13.93,4.51a20.38,20.38,0,0,1-12.26-1.07,12.76,12.76,0,0,1-7.94-12.79c.29-6.49,2.54-12.49,4.13-18.66,1.29-5,2.69-10.07,3.8-15.16a17.42,17.42,0,0,0-.06-5.39c-.2-1.92-1.48-3-3.35-3.35a16.54,16.54,0,0,0-9.41.9c-.47.18-1,.26-1.72.46.43-1.81.76-3.41,1.22-5a1.7,1.7,0,0,1,.94-.94c5-1.92,9.87-4,15.23-4.65a21.87,21.87,0,0,1,9.93,1c5.85,2,8.94,7.29,8.54,13.47-.43,6.91-2.93,13.28-4.57,19.87q-1.78,7.2-3.45,14.43a10.22,10.22,0,0,0-.16,2.54c.08,3.66,1.57,5.41,5.2,5.48a49.51,49.51,0,0,0,7.54-.81A17,17,0,0,0,70.7,89.16Z"
        fill="white"
      />
      <path
        d="M59.77,0C66.46.13,71.42,4.59,72,11c.42,4.48-2.34,8.9-6.89,11.06-6.23,2.95-14.09.32-17-5.68C44.43,8.68,50.69-.16,59.77,0Z"
        fill="white"
      />
    </svg>
  );
}
